// // import React, { useState } from "react";
// // import { useNavigate } from "react-router-dom";

// // const ResetPassword = () => {
// //   const navigate = useNavigate();
// //   const [email, setEamil] = useState("");
// //   const [password, setPassword] = useState("");

// //   const changePasswordChange = async (e) => {
// //     e.preventDefault();
// //     console.log("Email");
// //   };

// //   return (
// //     <section className="forgot-passwor">
// //       <div className="container vh-100">
// //         <div className="row bg-white p-4 mt-4">
// //           <div className="col-md-6 mx-auto">
// //             <h2 className="">Forgot your password?</h2> <hr />
// //             <div className="mb-3">
// //               <form onSubmit={changePasswordChange}>
// //                 <label for="" className="form-label">
// //                   Email address
// //                 </label>
// //                 <input
// //                   type="email"
// //                   className="form-control form-control-lg"
// //                   name="email"
// //                   id="email"
// //                   value={email}
// //                   onChange={(e) => setEamil(e.target.value)}
// //                   // onChange={(e) => setFirstName(e.target.value)}
// //                   aria-describedby="emailHelpId"
// //                   placeholder="Enter your email "
// //                 />

// //                 <button className="btn btn-outline-success btn-block btn-lg mt-2 text-uppercase">
// //                   RESET PASSWORD
// //                 </button>
// //               </form>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default ResetPassword;

// import React, { useState } from "react";
// import { useParams, useNavigate } from "react-router-dom"; // for handling URL params and navigation
// import axios from "axios";

// const ResetPassword = () => {
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const { token } = useParams(); // Extract token from URL
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Check if passwords match
//     if (newPassword !== confirmPassword) {
//       setError("Passwords do not match!");
//       return;
//     }

//     try {
//       // Send the token and new password to the server
//       const response = await axios.post(
//         "https://mahmoudosman-com.vercel.app/api/users/reset-password",
//         {
//           token,
//           newPassword,
//         }
//       );

//       setSuccess(response.data.message);
//       setError("");
//       // Optionally redirect user after successful reset
//       setTimeout(() => {
//         navigate("/login");
//       }, 2000);
//     } catch (error) {
//       setError(error.response.data.error || "Something went wrong!");
//     }
//   };

//   return (
//     <div className="container vh-100 ">
//       <div className="row bg-white p-4 mt-4">
//         <div className="col-md-6 mx-auto">
//           {" "}
//           <h2>Reset Your Password</h2> <hr />
//           {success ? (
//             <p className="text-success">{success}</p>
//           ) : (
//             <form onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <label htmlFor="newPassword">New Password</label>
//                 <input
//                   type="password"
//                   className="form-control form-control-lg"
//                   id="newPassword"
//                   value={newPassword}
//                   onChange={(e) => setNewPassword(e.target.value)}
//                   required
//                 />
//               </div>
//               {/* <div className="form-group">
//             <label htmlFor="confirmPassword">Confirm Password</label>
//             <input
//               type="password"
//               id="confirmPassword"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//               required
//             />
//           </div> */}
//               {error && <p style={{ color: "red" }}>{error}</p>}
//               <button className="btn btn-outline-success btn-block btn-lg mt-2 text-uppercase">
//                 RESET PASSWORD
//               </button>
//               {/* <button type="submit">Reset Password</button> */}
//             </form>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { USERS_BASE_URL } from "../services/SignUpService";

const ResetPassword = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.put(
        `${USERS_BASE_URL}/api/users/reset-password/${token}`,

        {
          token,
          newPassword,
        }
      );
      setMessage(response.data.message);
      navigate("/api/users/login");
      setError("");
    } catch (error) {
      setError(
        error.response.data.error ||
          "Something went wrong! Unable to reset password!!"
      );
      setMessage("");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row vh-100  justify-content-center">
        <div className="col-md-6 ">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title text-center">Reset Password</h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="newPassword" className="form-label">
                    New Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
                {error && <p className="text-danger">{error}</p>}
                {message && <p className="text-success">{message}</p>}
                <div className="d-grid">
                  <button type="submit" className="btn btn-primary">
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
